export default __webpack_public_path__ + "static/media/vip2.3e7247af.webp";